import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import AdminLink from "./adminLink";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";

function CompanySettings({ selectedOrgcode }) {
  const [loader, setLoader] = useState(true);
  const [isEmployeePaymentEnabled, setIsEmployeePaymentEnabled] = useState(false);
  const [isFamilyPaymentEnabled, setIsFamilyPaymentEnabled] = useState(false);
  const [isAnnualCheckup, setIsAnnualCheckup] = useState(false);
  const [isRestrictedPkgByDesignation, setIsRestrictedPkgByDesignation] = useState(false);
  const [isPackageByAge, setIsPackageByAge] = useState(false);

  const userRole = JSON.parse(localStorage.getItem("data")).role;
  const [companyDetails, setCompanyDetails] = useState(null);
  const [pemePackage, setPemePackage] = useState(null);

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [tests, setTests] = useState([]);
  const navigate = useNavigate();

  const getData = async () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const response = await axios.get(`/api/companydetails/companycode=${selectedOrgcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanyDetails(response.data);
      // Optionally initialize toggles from fetched data
      setIsEmployeePaymentEnabled(response.data?.requireEmpPayment || false);
      setIsFamilyPaymentEnabled(response.data?.requireFamilyPayment || false);
      setIsAnnualCheckup(response.data?.annualCheckupController || false);
      setIsRestrictedPkgByDesignation(response.data?.restrictedPkgByDesignation || false);
      setIsPackageByAge(response.data?.packageByAge || false);

      const pemePackageId=response.data?.pemePackageId;

      if(pemePackageId!==null){
      const pemePackage = await axios.get(`/api/package/${response.data?.pemePackageId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPemePackage(pemePackage.data); // Store the package data
    }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handleToggleChange = async (type, value) => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
        const payload = {
            id: companyDetails.id,
            sendNotification: companyDetails.sendNotification,
            validate: companyDetails.validate,
            requireEmpPayment: type === "requireEmpPayment" ? value : companyDetails.requireEmpPayment,
            requireFamilyPayment: type === "requireFamilyPayment" ? value : companyDetails.requireFamilyPayment,
            annualCheckupController: type === "annualCheckupController" ? value : companyDetails.annualCheckupController,
            restrictedPkgByDesignation: type ==="restrictedPkgByDesignation" ? value : companyDetails.restrictedPkgByDesignation,
            packageByAge: type === "packageByAge" ? value : companyDetails.packageByAge
          };
      await axios.post(`/api/companydetails/update`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
    
      const statusMessage =
      type === "requireEmpPayment"
        ? "Employee payment required status"
        : type === "requireFamilyPayment"
        ? "Family payment required status"
         : type === "restrictedPkgByDesignation"
        ? "Restricted By Designation Status"
        : type === "packageByAge"
        ? "Package By Age Status"
        : "Annual checkup controller status";

    toast.success(`${statusMessage} updated successfully!`);
      getData();
      setLoader(false);
    } catch (error) {
        setLoader(false);
      handleError(error);
    }
  };

  const [showModal, setShowModal] = useState(false);
const [selectedPackageId, setSelectedPackageId] = useState(null);
const [companyPackages, setCompanyPackages] = useState([]); // Store fetched packages

const openPackageModal = async () => {
  try {
    const token = JSON.parse(localStorage.getItem("data")).token;
    const response = await axios.get(`/api/package/companyId=${companyDetails?.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Filter out the package with pemePackageId
    const filteredPackages = response.data.filter(
      (pkg) => pkg.id !== companyDetails?.pemePackageId
    );

    setCompanyPackages(filteredPackages); // Store the filtered package data
    setShowModal(true);
  } catch (error) {
    console.error("Error fetching packages:", error);
    toast.error("Failed to fetch packages.");
  }
};


const closePackageModal = () => {
  setShowModal(false);
};

const handlePackageSelection = async(packageId) => {
  setLoader(true);
  const token = JSON.parse(localStorage.getItem("data")).token;
  try {
      const payload = {
          id: companyDetails.id,
          pemePackageId: packageId
        };
    await axios.post(`/api/companydetails/update`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

  toast.success(`PEME package updated successfully!`);
  closePackageModal();
    getData();
    setLoader(false);
     

  } catch (error) {
      setLoader(false);
    handleError(error);
  }
};



const [selectedPackage, setSelectedPackage] = useState(null);
const openTestsModal = (pkg) => {
  setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
};

const closeTestsModal = () => {
  setSelectedPackage(null);
  setIsTestsModalOpen(false);
};
  

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {userRole === "ROLE_SUPER" && <AdminLink selectedOrgcode={selectedOrgcode} />}

      <div>
        <div className="company-profile">
          <div className="card card-raised mb-5">
            <div className="card-body">
              <div className="card-title form-group d-flex align-items-center justify-content-between">
                <span>Company Settings</span>
              </div>
              <br />
              <div className="row">
  <div className="col-md-4">
    <div className="form-floating-sm mb-2">
      <label></label>
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="employeePaymentToggle"
          checked={isEmployeePaymentEnabled}
          onChange={(e) => handleToggleChange("requireEmpPayment", e.target.checked)}
          style={{ cursor: "pointer" }}
          title={isEmployeePaymentEnabled ? "Disable Employee Payment" : "Enable Employee Payment"}
        />
        <label
          className="form-check-label ms-2"
          htmlFor="employeePaymentToggle"
          style={{ cursor: "pointer" }}
          title={isEmployeePaymentEnabled ? "Disable Employee Payment" : "Enable Employee Payment"}
        >
          {isEmployeePaymentEnabled ? "Employee Payment Enabled" : "Employee Payment Disabled"}
        </label>
      </div>
    </div>
  </div>
  
  <div className="col-md-4">
    <div className="form-floating-sm mb-2">
      <label></label>
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="familyPaymentToggle"
          checked={isFamilyPaymentEnabled}
          onChange={(e) => handleToggleChange("requireFamilyPayment", e.target.checked)}
          style={{ cursor: "pointer" }}
          title={isFamilyPaymentEnabled ? "Disable Family Payment" : "Enable Family Payment"}
        />
        <label
          className="form-check-label ms-2"
          htmlFor="familyPaymentToggle"
          style={{ cursor: "pointer" }}
          title={isFamilyPaymentEnabled ? "Disable Family Payment" : "Enable Family Payment"}
        >
          {isFamilyPaymentEnabled ? "Family Payment Enabled" : "Family Payment Disabled"}
        </label>
      </div>
    </div>
  </div>


  <div className="col-md-4">
    <div className="form-floating-sm mb-2">
      <label></label>
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="annualCheckupToggle"
          checked={isAnnualCheckup}
          onChange={(e) => handleToggleChange("annualCheckupController", e.target.checked)}
          style={{ cursor: "pointer" }}
          title={isAnnualCheckup ? "Disable Annual Checkup" : "Enable Annual Checkup"}
        />
        <label
          className="form-check-label ms-2"
          htmlFor="annualCheckupToggle"
          style={{ cursor: "pointer" }}
          title={isAnnualCheckup ? "Disable Annual Checkup" : "Enable Annual Checkup"}
        >
          {isAnnualCheckup ? "Annual Checkup Enabled" : "Annual Checkup Disabled"}
        </label>
      </div>
    </div>
  </div>
  </div>
  <div className="row">
  <div className="col-md-4">
    <div className="form-floating-sm mb-2">
      <label></label>
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="restrictedPkgByDesignation"
          checked={isRestrictedPkgByDesignation}
          onChange={(e) => handleToggleChange("restrictedPkgByDesignation", e.target.checked)}
          style={{ cursor: "pointer" }}
          title={isRestrictedPkgByDesignation ? "Unrestrict Package By designation" : "Restrict Package By designation"}
        />
        <label
          className="form-check-label ms-2"
          htmlFor="restrictedPkgByDesignation"
          style={{ cursor: "pointer" }}
          title={isRestrictedPkgByDesignation ? "Unrestrict Package By designation" : "Restrict Package By designation"}
        >
          {isRestrictedPkgByDesignation ? "Restricted package by designation" : "Unrestricted package by designation"}
        </label>
      </div>
    </div>
  </div>
  <div className="col-md-4">
    <div className="form-floating-sm mb-2">
      <label></label>
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="packageByAge"
          checked={isPackageByAge}
          onChange={(e) => handleToggleChange("packageByAge", e.target.checked)}
          style={{ cursor: "pointer" }}
          title={isPackageByAge ? "Unrestrict Package By Age" : "Restrict Package By Age"}
        />
        <label
          className="form-check-label ms-2"
          htmlFor="packageByAge"
          style={{ cursor: "pointer" }}
          title={isPackageByAge ? "Unrestrict Package By Age" : "Restrict Package By Age"}
        >
          {isPackageByAge ? "Restricted Package By Age" : "Unrestricted Package By Age"}
        </label>
      </div>
    </div>
  </div>
</div>
{!companyDetails?.pemePackageId ? (
  <div className="col-md-4">
    <div className="mt-3">
      <a onClick={openPackageModal} style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}>
        Link Package for PEME
      </a>
    </div>
  </div>
) : (
  <div className="mt-4">
    <h5>PEME Package:</h5>
    {pemePackage ? (  // ✅ Correctly checking for empty array
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Package Name</th>
            <th>Package Code</th>
            <th>Price</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
            <tr key={pemePackage.id}>
              <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>{pemePackage.packagename}</span>
                <FiInfo
                  onClick={() => openTestsModal(pemePackage.id)}
                  style={{ cursor: 'pointer', marginLeft: "10px" }}
                  title="View Tests"
                />
              </td>
              <td>{pemePackage.packageCode}</td>
              <td>{pemePackage.price}</td>
              <td>
                <button onClick={openPackageModal}>Change Package</button>
              </td>
            </tr>
          
        </tbody>
      </table>
    ) : (
      <p>No packages available for this company.</p>
    )}
  </div>
)}

</div>
</div>
{isTestsModalOpen && (
            <TestForPackage
                    isOpen={isTestsModalOpen}
                    onRequestClose={closeTestsModal}
                    packageId={selectedPackage}
                  />
            )}

        </div>
        {loader && <div className="loading"></div>}
      </div>
      {showModal && (
  <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Select a Package</h5>
          <button type="button" className="close" onClick={closePackageModal}>&times;</button>
        </div>
        <div className="modal-body">
          <ul className="list-group">
            {companyPackages.length > 0 ? (
              companyPackages.map((pkg) => (
                <li key={pkg.id} className="list-group-item d-flex justify-content-between align-items-center">
                  {pkg.packagename}
                  <button className="btn btn-primary btn-sm" onClick={() => handlePackageSelection(pkg.id)}>
                    Select
                  </button>
                </li>
              ))
            ) : (
              <p>No packages available.</p>
            )}
          </ul>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
}

export default CompanySettings;
